'use strict';
angular.module('TurneroApp').component('coAsistenciaPersona', {
	bindings: {
		configuracionPantalla: '<',
		ciudadano: '='
	},
	controller: [
		 'turnosService',
		 'utilsService',
		 '$rootScope',
		 'TurneroAppConstant',
		 '$mdDialog',
		 '$sce',
		 'usuariosService',
		 '$scope',
		 function (turnosService, utilsService, $rootScope, TurneroAppConstant, $mdDialog, $sce, usuariosService, $scope) {
		 	var ctrl = this;

             ctrl.limpiarMemoria = function () {
                ctrl.Dar_Turnos_Multiples = false;
                ctrl.personaSeleccionada = null;
                ctrl.habilitarBuscar = false;
                ctrl.Busqueda = ctrl.Busqueda || {};
                ctrl.errores = {
                    PersonaCidi: false,
                    PersonaCidiString: ''
                };
		 	}

		 	ctrl.errores = {
		 		PersonaCidi: false,
		 		PersonaCidiString:''
		 	}

             ctrl.$onInit = function () {
                ctrl.Busqueda = {};
		 		ctrl.limpiarMemoria();
		 	};

             ctrl.limpiarVariables = function (filtro) {
                ctrl.habilitarBuscar = false;
                ctrl.Busqueda.Pai_Cod_Pais = null;
                ctrl.Busqueda.Id_Sexo = null;
                ctrl.Busqueda.Id_Numero = null;
                ctrl.Busqueda.CUIL = null;
                ctrl.Busqueda.DNI = null;
                ctrl.limpiarBusqueda();
                ctrl.Busqueda.Filtro = filtro; 		
		 	}

		 	ctrl.limpiarBusqueda = function () {
		 		ctrl.Busqueda = {};
		 		ctrl.Persona = null;
		 		ctrl.personaSeleccionada = null;
		 		ctrl.variasPersonas = false;
		 		ctrl.PersonasLista = null;
		 		ctrl.NoExiste = false;
		 		ctrl.errores = {
		 			PersonaCidi: false,
		 			PersonaCidiString: ''
		 		}
		 		ctrl.CidiCuil = "";
		 	};
		 	//Busqueda de persona
		 	ctrl.buscarPersona = function () {
				ctrl.errores.PersonaCidi = false;
		 		if (ctrl.Busqueda) {
		 			if (ctrl.Busqueda.Filtro == 'DNI' && (!ctrl.Busqueda.DNI || !ctrl.Busqueda.Id_Sexo)) {
		 			    sweetAlert("Campos requeridos", "El campo número de DNI y el sexo de la persona son requeridos para la búsqueda. <br/> Complételo y vuelva a intentarlo.", "warning");
		 			} else if (ctrl.Busqueda.Filtro == 'CUIL' && !ctrl.Busqueda.CUIL) {
		 			    sweetAlert("Campo requerido", "El campo número de CUIL es requerido para la busqueda. <br/> Complételo  y vuelva a intentarlo.", "warning");
		 			} else if (ctrl.Busqueda.Filtro == 'PSP' && (!ctrl.Busqueda.PSP || !ctrl.Busqueda.Pai_Cod_Pais || !ctrl.Busqueda.Id_Sexo)) {
		 				if (!ctrl.Busqueda.PSP) {
		 				    sweetAlert("Campo requerido", "El campo número de documento extranjero es requerido para la búsqueda. <br/> Complételo y vuelva a intentarlo.", "warning");
		 				} else if (!ctrl.Busqueda.Id_Sexo) {
		 				    sweetAlert("Campo requerido", "El campo sexo es requerido para la búsqueda. <br/> Complételo y vuelva a intentarlo.", "warning");
		 				} else if (!ctrl.Busqueda.Pai_Cod_Pais) {
		 				    sweetAlert("Campo requerido", "El campo país es requerido para la búsqueda. <br/> Complételo y vuelva a intentarlo.", "warning");
		 				}

		 			} else {
		 				ctrl.Persona = null;
		 				ctrl.PersonasLista = null;
		 				ctrl.Id_Persona = null;
		 				var filtro = {
		 					Id_Tipo_Doc: ctrl.Busqueda.Filtro,
		 					Nro_Documento: ctrl.Busqueda.Filtro == 'DNI' ? ctrl.Busqueda.DNI : (ctrl.Busqueda.Filtro == 'CUIL' ? ctrl.Busqueda.CUIL : ctrl.Busqueda.PSP),
		 					Id_Numero: ctrl.Busqueda.Id_Numero,
		 					Id_Sexo: ctrl.Busqueda.Id_Sexo,
		 					Pai_Cod_Pais: ctrl.Busqueda.Filtro == 'DNI' || ctrl.Busqueda.Filtro == 'CUIL' ? 'ARG' : (ctrl.Busqueda.Pai_Cod_Pais ? ctrl.Busqueda.Pai_Cod_Pais.id : ctrl.Busqueda.Pai_Cod_Pais)
                        }

                        

                        utilsService.swalTitle('Buscando ciudadano', 'info');

                        if (ctrl.Busqueda.Filtro == 'CUIL') {
                            turnosService.ValidarCuilCuit({ 'Cuil_Cuit': ctrl.Busqueda.CUIL }).$promise.then(function (resultado) {
                                if (resultado.Data == false) {
                                    var Cuil = ctrl.Busqueda.CUIL;
                                    ctrl.limpiarBusqueda();
                                    ctrl.Busqueda = {
                                        Filtro: "CUIL",
                                        CUIL: Cuil
                                    };
                                    swal.close();
                                    sweetAlert("Cuil Inválido", "El Cuil ingresado no tiene un formato válido. <br/> Corríjalo y vuelva a intentarlo.", "warning");
                                } else {
                                    BuscarDatosPersona(filtro);
                                }
                            }).catch(function (error) {
                                utilsService.errores(error);
                            });
                        } else {
                            BuscarDatosPersona(filtro);
                        }
		 			};
		 		} else {
		 		    sweetAlert("Campos requeridos", "El campo tipo de documento y número son requeridos. <br/> Complételo y vuelva a intentarlo.", "warning");
		 		}
		 	};

             function BuscarDatosPersona(filtro) {
                 turnosService.Get_Persona(filtro).$promise.then(function (resultado) {
					console.log(filtro)
					console.log(resultado)
                     if (resultado.Data.length == 1) {
                         if (!resultado.Data.Datos_RegistroCivil) {
                             ctrl.NoExiste = true;
                             ctrl.altaPersona = {
                                 Id_Sexo: ctrl.Busqueda.Filtro != 'CUIL' ? ctrl.Busqueda.Id_Sexo : null,
                                 Sexo: ctrl.Busqueda.Id_Sexo ? (ctrl.Busqueda.Id_Sexo == '01' ? 'Masculino' : 'Femenino') : null,
                                 Nro_Documento: ctrl.Busqueda.Filtro == 'DNI' ? ctrl.Busqueda.DNI : (ctrl.Busqueda.Filtro == 'CUIL' ? ctrl.Busqueda.CUIL.toString().substring(2, ctrl.Busqueda.CUIL.toString().length) : ctrl.Busqueda.PSP),
                                 Pai_Cod_Pais: ctrl.Busqueda.Filtro == 'DNI' || ctrl.Busqueda.Filtro == 'CUIL' ? 'ARG' : (ctrl.Busqueda.Filtro == 'PSP' ? ctrl.Busqueda.Pai_Cod_Pais.id : null),
                             }
                         }

                         ctrl.variasPersonas = false;
                         ctrl.Persona = resultado.Data[0];
                     } else if (resultado.Data.length > 1) {
                         ctrl.variasPersonas = true;
                         ctrl.PersonasLista = resultado.Data
                     } else {
                         ctrl.NoExiste = true;
                         ctrl.altaPersona = {
                             Id_Sexo: ctrl.Busqueda.Filtro != 'CUIL' ? ctrl.Busqueda.Id_Sexo : null,
                             Sexo: ctrl.Busqueda.Id_Sexo ? (ctrl.Busqueda.Id_Sexo == '01' ? 'Masculino' : 'Femenino') : null,
                             Nro_Documento: ctrl.Busqueda.Filtro == 'DNI' ? ctrl.Busqueda.DNI : (ctrl.Busqueda.Filtro == 'CUIL' ? ctrl.Busqueda.CUIL.toString().substring(2, ctrl.Busqueda.CUIL.toString().length) : ctrl.Busqueda.PSP),
                             Pai_Cod_Pais: ctrl.Busqueda.Filtro == 'DNI' || ctrl.Busqueda.Filtro == 'CUIL' ? 'ARG' : (ctrl.Busqueda.Filtro == 'PSP' ? ctrl.Busqueda.Pai_Cod_Pais.id : null),
                         }
                     }
                     swal.close();

                 }).catch(function (error) {
                     utilsService.errores(error);
                 })
             }

		 	//Seleccionar una persona
		 	ctrl.seleccionarPersona = function () {
		 		ctrl.personaSeleccionada = ctrl.Persona;
		 		$rootScope.$broadcast('cambioPersonaSeleccionada', ctrl.Persona);

		 	};

		 	//Obtener Paises para pasaporte
		 	usuariosService.getPaises().$promise.then(function (data) {
		 		ctrl.Lista_Paises = data.Data;
		 	}).catch(function (error) {
		 		utilsService.errores(error);
		 	})


             $scope.$on('LimpiarPersonas', function (event) {
                 if (!ctrl.Dar_Turnos_Multiples) {
                     ctrl.cambiarPersona();
                 } else {
                     $rootScope.$broadcast('cambioPersonaSeleccionada', ctrl.personaSeleccionada );
                 }
		 	})

		 	//Cambiar persona seleccionada.
             ctrl.cambiarPersona = function () {
                ctrl.Busqueda = ctrl.Busqueda || {};
                ctrl.Busqueda.Id_Sexo = '';
                ctrl.Busqueda.DNI = '';
                ctrl.Busqueda.CUIL = '';
                ctrl.Busqueda.PSP = '';
                ctrl.Busqueda.Filtro = '';
                ctrl.NoExiste = false;
                ctrl.Persona = null;
                ctrl.PersonasLista = null;
                ctrl.personaSeleccionada = null;
                ctrl.Dar_Turnos_Multiples = false;
                $rootScope.$broadcast('cambioPersonaSeleccionada', null);	 		
		 	};

		 	//Buscar por CUIL
		 	ctrl.buscarPersonaCuil = function () {
		 		var filtro = {
		 			Id_Tipo_Doc: 'CUIL',
		 			Nro_Documento: ctrl.CidiCuil,
		 		}
		 		ctrl.errores.PersonaCidi = false;
		 		turnosService.Get_Persona(filtro).$promise.then(function (result) {
		 			if (result.Data && result.Data[0].Datos_Cidi) {
		 				var Resultado = result.Data[0].Datos_Cidi;
                        var DNI_Cidi = Resultado.N_Ciudadano_Cidi.substring(2, Resultado.N_Ciudadano_Cidi.toString().length)
		 				if (ctrl.Persona.Datos_RegistroCivil.Nro_Documento == DNI_Cidi) {
		 					ctrl.Persona.Datos_Cidi = Resultado;
		 				} else {
		 					sweetAlert("CUIL no valido", "Este CUIL no pertenece a la persona que está buscando.", "warning");
		 				}
		 			}

		 		}).catch(function (error) {
		 			utilsService.errores(error);

		 		})
		 	}

		 	ctrl.seleccionarPersonafromList = function () {
		 		ctrl.Persona = ctrl.PersonasLista[ctrl.Id_Persona]
		 	}

		 	ctrl.mostrarModal = function (tipoModal) {
		 		ctrl.URL = "";
		 		ctrl.tipoAlta = tipoModal;
		 		if (tipoModal == 'CIDI') {
		 			ctrl.URL = TurneroAppConstant.vedi.url + TurneroAppConstant.vedi.endpoint.alta + TurneroAppConstant.vedi.ciDiIdAplicacion; //TurneroAppConstant.cidi_Alta.url;
		 			if (ctrl.Busqueda.Filtro == 'CUIL' && ctrl.Busqueda.CUIL) {
		 				ctrl.URL = ctrl.URL + '/' + ctrl.Busqueda.CUIL
		 			}
		 			if (ctrl.URL) {
		 				ctrl.URL = $sce.trustAsResourceUrl(ctrl.URL)
		 				$mdDialog.show({
		 					template: require('./modalAltaPersona.html'),
		 					parent: angular.element(document.body),
		 					clickOutsideToClose: false,
		 					fullscreen: false, // Only for -xs, -sm breakpoints.,
		 					controllerAs: '$ctrl',
		 					controller: function () {
		 						return ctrl;
		 					}
		 				});
		 			}
		 		} else if (tipoModal == 'RCIVIL') {

		 			usuariosService.Post_Persona(ctrl.altaPersona).$promise.then(function (result) {
		 				ctrl.URL = result.Data;

		 				if (ctrl.URL) {
		 					ctrl.URL = $sce.trustAsResourceUrl(ctrl.URL)
		 					$mdDialog.show({
		 						template: require('./modalAltaPersona.html'),
		 						parent: angular.element(document.body),
		 						clickOutsideToClose: false,
		 						fullscreen: false, // Only for -xs, -sm breakpoints.,
		 						controllerAs: '$ctrl',
		 						controller: function () {
		 							return ctrl;
		 						}
		 					});
		 				}
		 			}).catch(function (error) {
		 				utilsService.errores(error);
		 			})
		 		}

		 	}

		 	ctrl.cerrarModal = function () {
		 		$mdDialog.destroy();
		 		ctrl.buscarPersona();
		 	};

		 	ctrl.validarHabilitarBuscar = function () {
		 		if (ctrl.Busqueda.Filtro == 'DNI') {
		 			if (ctrl.Busqueda.DNI && ctrl.Busqueda.DNI >= 1 && ctrl.Busqueda.DNI <= 999999999 && ctrl.Busqueda.Id_Sexo) {
		 				ctrl.habilitarBuscar = true;
		 				return
		 			} else {
		 				ctrl.habilitarBuscar = false;
		 				return
		 			}
		 		}
		 		if (ctrl.Busqueda.Filtro == 'CUIL') {
                    if (ctrl.Busqueda.CUIL && ctrl.Busqueda.CUIL.toString().length > 3 && ctrl.Busqueda.CUIL >= 1 && ctrl.Busqueda.CUIL <= 99999999999) {
		 				ctrl.habilitarBuscar = true;
		 				return
		 			} else {
		 				ctrl.habilitarBuscar = false;
		 				return
		 			}
		 		}
		 		if (ctrl.Busqueda.Filtro == 'PSP') {
		 			if (ctrl.Busqueda.PSP && ctrl.Busqueda.PSP.length && ctrl.Busqueda.Id_Sexo && ctrl.Busqueda.Pai_Cod_Pais) {
		 				ctrl.habilitarBuscar = true;
		 				return
		 			} else {
		 				ctrl.habilitarBuscar = false;
		 				return
		 			}
		 		}
		 	}

             ctrl.getIdentificadorPersona = function () {
                 if (!ctrl.Persona) return '';
                 var cuil = ctrl.Persona.Datos_Cidi && ctrl.Persona.Datos_Cidi.N_Ciudadano_Cidi;
                 var dni = ctrl.Persona.Datos_RegistroCivil && ctrl.Persona.Datos_RegistroCivil.Nro_Documento;
                 return cuil || dni || '';
             };

		 	ctrl.usuarioCidi = function (CUIL) {
		 		ctrl.errores.PersonaCidi = false;
		 		ctrl.errores.PersonaCidiString = ""
		 		var cidiCUIL = utilsService.getNumbersInString(CUIL);
		 		if (cidiCUIL.length == 11) {
		 			usuariosService.getCiDiInfo({ 'CUIL': cidiCUIL }).$promise.then(function (data) {
		 				if (data) {
		 					if (ctrl.Busqueda.Filtro == 'CUIL' && ctrl.Busqueda.CUIL == data.CUIL) {
		 						ctrl.errores.PersonaCidi = false;
		 					} else if (ctrl.Busqueda.Filtro == 'DNI' && ctrl.Busqueda.DNI == data.NroDocumento) {
		 						ctrl.errores.PersonaCidi = false;
		 					} else {
		 						ctrl.errores.PersonaCidi = true;
		 						ctrl.errores.PersonaCidiString = "El CUIL ingresado no pertenece al mismo ciudadano.";
		 						return;
		 					}
		 					if (!ctrl.errores.PersonaCidi) {

		 					    ctrl.Persona = data;

		 						ctrl.Persona.Datos_Cidi = {
		 							EMail: data.Email,
		 							Id_Tipo_Documento: ctrl.Busqueda.Filtro,
		 							N_Ciudadano_Cidi: data.CUIL,
		 							Nivel_Cidi: data.Id_Estado,
		 							Telefono: data.CelFormateado
		 						}
		 					}
		 				}
		 			}).catch(function (req) {
		 				ctrl.errores.PersonaCidi = true;
		 				var msj = "";
		 				var errors = req.data.ExceptionMessage ? req.data.ExceptionMessage.split(",") : req.data.Message.split(",");

		 				if (errors.length > 0) {
		 					if (errors[0] = "USU_NOT") {
		 						ctrl.errores.PersonaCidiString = "No se encontró el CUIL en Ciudadano Digital.";
		 					}
		 					else {
		 						ctrl.errores.PersonaCidiString = req.data.ExceptionMessage ? req.data.ExceptionMessage : req.data.Message;
		 					}
		 				}
		 			})
		 		} else {
		 			ctrl.errores.PersonaCidi = true;
		 			ctrl.errores.PersonaCidiString = "El Cuil ingresado, no es valido."
		 		}

		 	}

		 }],
	template: require('./asistencia_Persona.html')
});



// WEBPACK FOOTER //
// ./app/components/asistencia/asistencia_PersonaComponent.js